import sakanetImage from "../images/Sakanet-login.png";
import heroImage from "../images/HeroImage.jpg";
import CSHelpdesk from "../images/CSHelpdesk-Dashboard.png";
import PromoSystems from "../images/Promo-systems.jpg";
import VideoCallDesktop from "../images/Desktop-version-video-call.png";
import VideoCallAndroid from "../images/android-version-video-call.jpeg";
import VideoCallIOS from "../images/iOS-version-video-call.png";
import AlteronHomepage from "../images/Alteron - Homepage.png";
import TrackITDashboard from "../images/TrackIT-Dashboard.png";

export const Bio = {
  name: "Stephanie Encomienda",
  roles: ["Full Stack Developer", "Web Developer", "Software Developer"],
  description:
    "I am a Full Stack Developer specializing in end-to-end web application development. I oversee feature implementation, manage deployments, and coordinate technical solutions across frontend and backend systems. With hands-on experience in building scalable applications and a passion for clean code, I deliver robust solutions that drive business outcomes.",
  github: "https://github.com/imsteff",
  resume:
    "https://drive.google.com/file/d/1C8SrK2Deozj2YbVFWVcM8Z3JqGbtFU47/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/imsteff-encomienda/",
  facebook: "https://www.facebook.com/stef.encomienda",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEWCgoL////l5eXk5OTm5ubu7u74+Pj19fXx8fH7+/vr6+t+fn52dnZ7e3t8fHzz8/OGhoaTk5Pa2tq3t7e7u7utra3Q0NCZmZnFxcWkpKSMjIzKysqpqanX19e/v7+dnZ1ra2tH/Sn9AAASPElEQVR4nOVdbZuyKhBWwTcErcxqa7fO//+VB9RKGF6tdvWc+bLPNY+m48DMzc0AURzHWYKTjP9FOEn5nzTBaKJNPLW5UYtxQozawqYtH1o8V4ui/4eFKEG9hcn4fgmaqU2S0ZaHNndpi0Fbjlr8Ni0atVGWZXmapjn/y/8U/E/B//6etnmnttFoI/4BemcgxUVBWuLS8iaES/6XENLwPw1vSpPPngzXPj67TYtDtIhrI6ztZm/pkuKZDbcpLgt0uV73+7b74tJ1bdterztUZDgl5Se6JJpoP+ZD/uNNnKNTdztHlFJWV7LUjCuj8609oIx/hfRzPvxI3yqanBzaIzeNGxbZpKq4pdG2PeBcdKKXepyhH747lgotut4iyuymKYYyGt1O6aRpvi+WvrXzYZKSXbehDscZrKxp1F1wms7sfNZ8iAa/oLGbIeSjJRrt9RjmO+hLtj31HkDD+6GhS6Kxm3losaKNAs0yG9uQ042+Yt1dano8lS+ahT6QLUjH2BvMG42sOxKTt2WLV8MLwqT42b7FfU+p6PYkUunrQSd6PUU0pK3e576nsKgl8euJQ84W4ck/IWj/UmyxScW+EQlO/gi9M1vkqPuYfYONXfGWbDHbh+1H7Rts3AdCNUX7Qj/M8lNUf9g+IXV0KssX+uH8WIo2n4gvOmFnFAjVprF0bj7Mvukv2SeEfudkbj6cBdUScnhz/nMJ745kHoCbh0uz2286cBB2K3NvqDbFpeHZAse/7cBBKnpKfZvmS1wbSY6/78BB2FGid/wAXPAYvznMGvy9R6rqEH+Ya0ua6185cBDaEm1eQO/i2vDxt3KgSdgRuUmA2Vwb2W3+roXepdqgIAAX0g/zw187cBB2yD/DtaXt33bBp/DO6IBqs0ZP6dcyPCiEfZXeAM4b0xTH3xhH+Aq72aHaFNP4RRqcnP8+xkylOqO3ZguMFhBEZRlCqgmqhXJtJdr8tUE6yd/GtZVkaQ4cJS0n75tqE0fqw7VhtFADo2j3Fq4NL7OJ9rJ5C9eWLNdAHlHdAM7ZD/OFpQlZqm2hQrU8kGtLj0s2kJt4dAE4Rz5Mv5aEZHRS6wCcP9eWt8vBoiahJzuAs0YacljKaMIm9IKtkcaWLXbL96AQtsMWAGcZHyZ4wXlCkk0410Z6Vm3hYfQp1TZWoJoX19Zc19FGhbCOhI+e8M8aosxd6CGYa8PJX790mFTBXFu8mk44SHUsIdeW27i2VWTCqdALCeHakmxtBnITrflQ5drIbV1ttJctCeDaVtdGhdCDPtLossUK26gQmjW+XNv3Ctsol+o7s3NtZEwcGVqnC7kTf0YriJ1ry9cCuKGc/bi203rwqCrs4sW1/fVrviKVB9fWtEtnZmxSt42La0vQetuoELZzcW2kW2emuEvVObm2dbtQpH0719bs1+1CkfaJbWyBydpdyIONNVuQdu0u5E5sCeTaSErEGJ+kxfoN5CYWI9c2ADh59PQT3EjF4roqOh+3x/OG/5u5y/oAJvT9qup1GwO6ZD+xmWvbej5sfCSj5/ZARAMfJCM/+1tlLz5lRawI8QP61Zd649Fw5TZOTFyb57PGV2VfP6X6UCGojay/A27wI2Yr9TbjrBFFyXQEnOcj15ZnTUC2p+eDzrpRdluzjdAX8dbjuTRRbjLzuVVX5gPXlitcm3+qoEdksa935Nn4Y/SiXty42w5rlXtyy8uy2JAPfYdNbLNz2CfkZHxtmqrXXpxPPqu32PzODgau7eZnIL162Ce+4tk0StmAa13tlKrxyTp1W91kru1BknrFmaqv8PCTzvCL9bd6pYP7omqn3zmuR4lubHH1iTMUxgmLXAwvAt7YEjciTXDKHK262uPHngVPH6am9CK92j7EQPO3Zo16pY2DBoni7HrPSYUGH+OTYYzvkwxhGJxrIogcpZlaoGrgdtdPUJJDrs1j0h42LrcYmh+I/uauBS51dML+nl0Os4U73fd1HUDK5HDat/vrAWW6/zZlDQoyjomHVt1ty4R3qbocjp6cLCnr4Ovj9nzf1YND8HOrAg8hX/o3ZwDy6R8LEoUPAoo2mcy1cZDjJLqrLXj3n7OCsistmNN/O/h72lcAXd+viIlibpTEtRVO+oKpjRCddW+kATzY0BUBcuhgtBHJWxKPTtj/uPgwUj5sDG3pIaDfGFdfwJRpYA5AjNRkgUppy65M+LhPgAqJa8t97phIaUbWfKiqAk/TtaqFIGOBj+DVCe+/PeXasCsbKnGhtI/M1RczLCcCTTDeyxeCRLH3H/7s5P3asGNJk9pnXNQDxfL1hkANEYTcTtVE4dkJhdQnOVs4SbbQtkJlWGYigKgK49OpDWqi8O2EQqqWTLk20thBKZNzgE/AVj6/6TIwkJoMUoGH/Tshl2Mjc232q2Xo6zXMUrrQyQA71Qg2YcNALw0s55W5Nvv4rJZ7oRPZ9yI3sdKYW1SIkN+vVEFPQCfsfziXuDY7oqH59EmepSiKC4zVDwCVjYNKNR6XgVwuv//OteV52pgake5d/VyoRhHz0AUMpPqSOpAoQgvt6lPT2zbEUvusIZPgjHdjUbqY0UKA6HtvqXYH19RX3VAbPeRDYiWhqPQoF7ybvLrnffRHsYb3AzWNzKiAuZGnhYjYWp7Ckvh/Sya9uYUxrKV+Lr6GmihCO6GQ82jhEEttV9bSwDcgolVS80vNN4KBVKkmiqBMeJfp2MIYy4XIDSZkklhOo5YLmYPg8oej0x8tJ1xbYbNQ7k4hdZkydLPdCQdSU5lXhkaLwYeEkKK0/sRRelpISZgchK3eB4ThRLJ5FT4MpYSk5RBLbfMGlZyYgibgpHhhnX6t5O8oycyS8/7pYyzFV8tXklF3wzb+EkndyxJqxGO0RJ6Ques+6v3UQttEjmsizVcsnK8QMJAaZXYtaHWNH1xbaesicC5srji6MJyR6r/L7OKJ6ppz2/IhllotfJeBrioBzeRwPLsTit/bk2c+tI3w32ehk87TcK0vLL7iFj65Nhvwrt9mobMcSdMVZ9snIBV5cG3E9nX13WOOOOGQpp3aA7D718ZY+ksWWgeh/TvpbpptYj+svVtoA1RggDpbXPUIeug2O9TcLRR8VGHz4fv6ocNCOKXYiyONWiz8ikWx3sDT2CIN0z53loX2dzU1lrkp/x5p+mxhs1DOFqL8dqZgeywFjNRDunkZo+rSJ9dmzYfSAJz8Q2eL3UDLDLov96VYyDP+nWtrbBYyaQrihehtfx0wSfPyQ6s2e3Bt1vYjD/I+ZqHFQHNdjv0nReTyGVvINI2V75gvgP5VTJyz4vM+thgstI2AZTrzIxaqiaJQYcacEUY9+rCPpdZamvkshreoiWILaq9mpAy2688eGCy03i8nRJ/asFBRh6AnBkF4+D4yFBFPrk1OVB9YNaTSv31BLcj/wSmDNhOuzTq55k1dzxSQKHpbAIXqUUgsC82eXBvC1jeQwkBQtbuXqIliDHugnQanjOnMTGptAnKDmWuISdRCnUfGBe00MGWcpZkZ+9yTVA0V0hHZVAyXqCOKs/F/Aj/ubfRhURRNXlpBsdwRDTVc2hsvu4noiSjVU5MpCrVkJSxlVG3JbbtzbaaSnvFamVzwX1gj5xntJWqikLu56sSQGRp2kOra7F9HflP/SWDpy2hDFFMLSqSAUIN6z4BlS2Ief1LXZq/FkJup92PkGKJjaUCiUJwEeI2AlMGjx7OuLcHEfrUM3HzHFzK41IEhlSGBfVx1YsCeJESU85bJ3UI7GFN6ix//JY9pdRVboKITJK0KtFPvMoIjCalrUx/ks5uiMl+mwUKgm2mwJ+TfPA2c1rWVOQc3jtpEqtQS+MyrO9wDE4U+D6kW+i3t4TFMrCEts0ddmyPLgfIz5wkClVw0rQnAYFJLOzCD8dQvZYgZdmkNqatGGGRf05qm0b6NUhUO469viTpsp36xPFbWkDYu0AdQ4o/lMCtQ6g1dCBKFOSWrT8492ulQ5/3g2ji4yVyTCrCyPm4N/CCLADMIG6Baom4mD2A79UgZ9bXhiE3Y9lhR4kxymqmvvGPAkRWN4Iw83C8Flv5b1j2B9Q3ulEF3GKwKchMwunXNh+/oeRJuzejmW7O+FDZA4BcrbAT+dqeMTQbXkDpHRZpFM4Mnd5e9OMq42192aoFaLw0MIaBX258M5hVdA5yqfZwNxWMp7tcfYjc9UQetrnwKbB2gxTs+L2ynjtlvdhlOXcaTNaQYu9MMm2Ui3BAcLIJzDvzgMjA75mDJzDWkzDa7oJccLs2AcxTOB8Nb7CsTpmtIB66tLEjqnITmUp/1iwyNomsZteoQD2IEVNlaU0Z9SnNu1IRrG3Yc8Bsx+KzFf4huFAJ+wWtIDdvptyW/GHYc8FuPT8EKCaPkuhPaYAL3eqxm+s2Y3/r1+LodeDz3VKgA9WCQkxbzgEThSd7BdmpMGYKTePqw59rynGOcwrsmgG08ljxfIu0HA4nCm/aB7dSUMmg+GDXl2ob92vypUFZdtcn9LunecAgySBT+82bem6KIzbAM+7WFMPbifHBDvSQ+Gc+whoWyATuJwnaqJ9Aowsb92sL2GKppddwfyMSZOTmITYYsrV19x6DFTGApcqzdXm4bg/3a7uePkfBtL8UidVZtztvteRP1/7b65HzcyhL2tI1y91aHUtipX7rN/RhPuLZxvzYHqbgS+d/t11aWgmsjOf/L/6Tr33OPCahWlg23JisnXNu42/VaN0l+ipjPtZ6N8B/Z+9JyNgJZuRN7jk3esXzk2sY/Ta6hHNYkrCgGa5pC5dri+9kItvUzi5f66nM2wpqbaeV1NsLa9/NWz0Z4cG09yBFbZJTzClaXIBsyQjWMn7EUno1gX424ZKE/WDkbQbPbNcK8wfov116UiLMR7hYihWsry4L/fQA4n920Figsf0C1Jwwt5WwxJn+yosOsnsLGrQS9ziFNV3nOTBpyDumHyrk/KfTR+RQfTri2CYDLV5cU2amUrNBzbRN3ktWd2dXEmlPJrOeQ/vU7B0oSfA4pXtWZT/ez80znkHJbe65NAnAzquP/TEQZhQTVjFybfJjHarpiP/8uQTWQLTDSWJgs+bxqSTYAqk0tlLk2CcClazlLFqUqVDNzbUryX0W0EdMZKlTzOYc0WdWZzrZTq60+TMnX0k1kw7ncifkcUhnkKACuycuFY/DqFuugmpVrUwEcLIdZkFRnPVTzPZd7mHNbcs7YTDpfEnIOqQzg/toMi5igmoVrGwGcpHXVD/+dZCXWQjVs59pgg13qIUm5Eaq5uDbVwnKJDbXiBhqhmotrgwAOb5bmxuqMSzNUc3FtcvIf4s/CkoZIExaoFpYtBm0xa3PGT0l9hHnBmi2sPrwDuNtyABy7OaCamWtrLAAu3i9lpEH3LqjmwbWNWtmd12WYKBbFOaCaF9em0ZKfJfTFeufufD5cm1aLkfGUqt8Sdu7fzAHVDFybB4CLy++/bam0Hd5MhmpYhWoTrSVbID0D9/5tIwKk3yzHA6r5cW0GLbEci/dhYVuEVVCmh2qeXJsEiCba8o/SBt0X/Ttk2jcL5dqQTUt2f+BGdu6PzEy8oJo316YHcFxL9HX4n5OKtinW5AWPbGHn2sza/PabTZXeUqIHZU5tZIRqDm2TGZYbfEBYdMkAiNRDS6jVcW2q4wzaIr5algK/Typ2JcQIyt7BtVm0PP9/2saKdplf53uBazNoxe/ku9tHbazokUwDqATK9FoL1yaSKYRqd21u0hZfH7OR+6+IG/AOE1DmAeAgE2UBcIlWS1BHPxFzatohXQbwgWqhXJtdy7Njetm82ZEV3Vwx8QBl7+LaTADufm0c777e6EhGv3ZxagNlZqimal+MNA9tgsv4YFzQFSQ8uhxSgsNjiiHSvJQtplrx62i/pS/lyKqm22s2Ly+8zLX5aHmXJGKXhXqOlVXFou6EyDCE9wVl7+HaQrR5nmXodItYkJUVo9HtuhNbbweCMqfWiLyDAJxGuzt9b/stM5ztkhu37U48WDV4Bih7L9cW0iV5b2jiHJ262zmilD12B6meu4RQGp2P3QWJ0Jc+u87zF5LZnW821+YVViVtI5Ja2aDLdb/ft93X7fbVdW3b7q871GT8P6VRrQcoCw6req5tJoC7ayGk6ktXSJ/BY5KSHgoRy7VWUBYG4KxMVBCAy21aArVyI9RrZ0O1l7g2K4BLVG0+aIlR+yoo+wjX9prWC369rn0AuE9HmlTu+3rtRyPNv+c/cIe0nzmlAAAAAElFTkSuQmCC",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "PHP",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/php/php-original.svg",
      },
      {
        name: "Laravel",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/laravel/laravel-plain-wordmark.svg",
      },
      {
        name: "CodeIgniter",
        image: "https://cdn.worldvectorlogo.com/logos/codeigniter.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "GitLab",
        image:
          "https://about.gitlab.com/images/press/logo/svg/gitlab-logo-500.svg",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Adobe XD",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/c/c2/Adobe_XD_CC_icon.svg",
      },
      {
        name: "Figma",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg",
      },
      {
        name: "Adobe Photoshop",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/a/af/Adobe_Photoshop_CC_icon.svg",
      },
      {
        name: "cPanel",
        image: "https://www.vectorlogo.zone/logos/cpanel/cpanel-icon.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/C560BAQGkid6FomN6bQ/company-logo_200_200/company-logo_200_200/0/1630636iken049/megasportsworld_logo?e=2147483647&v=beta&t=7LhQYPLLhBuILZXYKNmxJZJpJXWmXPKN9p3vZ0vKq5c",
    role: "Tech Lead Full Stack Developer",
    company: "MegaSportsWorld",
    date: "Jun 2026 - Present",
    desc: "• Lead technical direction and architecture decisions across web application projects\n• Oversee end-to-end development, deployments, and technical coordination between frontend, backend, and support teams\n• Serve as point person for development tasks, code reviews, and technical mentoring\n• Collaborate with external development teams via GitLab on critical projects (MSW Video Calling, Avaya to Twilio migration)\n• Drive code migration and system modernization initiatives",
    skills: [
      "React JS",
      "Vite.js",
      "PHP",
      "Laravel",
      "CodeIgniter",
      "MySQL",
      "Git",
      "GitLab",
      "Deployment Management",
    ],
    doc: "",
  },
  {
    id: 1,
    img: "https://media.licdn.com/dms/image/v2/C560BAQGkid6FomN6bQ/company-logo_200_200/company-logo_200_200/0/1630636iken049/megasportsworld_logo?e=2147483647&v=beta&t=7LhQYPLLhBuILZXYKNmxJZJpJXWmXPKN9p3vZ0vKq5c",
    role: "Full Stack Developer",
    company: "MegaSportsWorld",
    date: "Oct 2025 - May 2026",
    desc: "Official Designation: Junior Officer – Full Stack Developer\n\n• Oversee end-to-end development and maintenance of web applications\n• Manage deployments and coordinate technical solutions across frontend, backend, and support teams\n• Serve as point person for development tasks and technical coordination\n• Collaborate with external development teams via GitLab on critical projects (MSW Video Calling, Avaya to Twilio migration)\n• Lead code migration projects and system modernization initiatives",
    skills: [
      "React JS",
      "Vite.js",
      "PHP",
      "Laravel",
      "CodeIgniter",
      "MySQL",
      "Git",
      "GitLab",
      "Deployment Management",
    ],
    doc: "",
  },
  {
    id: 2,
    img: "https://media.licdn.com/dms/image/v2/C560BAQGkid6FomN6bQ/company-logo_200_200/company-logo_200_200/0/1630636iken049/megasportsworld_logo?e=2147483647&v=beta&t=7LhQYPLLhBuILZXYKNmxJZJpJXWmXPKN9p3vZ0vKq5c",
    role: "Junior Full Stack Developer",
    company: "MegaSportsWorld",
    date: "Apr 2025 - Oct 2025",
    desc: "• Developed and maintained web applications using React.js, PHP (Laravel, CodeIgniter), and Node.js\n• Implemented responsive front-end designs with HTML5, CSS3, and JavaScript\n• Built and optimized RESTful APIs and database queries using MySQL\n• Collaborated with teams using Git/GitHub and Agile methodologies via Jira",
    skills: [
      "React JS",
      "PHP",
      "Node JS",
      "MySQL",
      "HTML5",
      "CSS3",
      "JavaScript",
      "Git",
    ],
    doc: "",
  },
  {
    id: 3,
    img: "https://media.licdn.com/dms/image/v2/C4D0BAQFQy_VxG5xZUQ/company-logo_200_200/company-logo_200_200/0/1631346298878?e=2147483647&v=beta&t=9Cw8WxqQxJ6YqZLqN7BxX4Z2xJ3cZ9xZ9Z9Z9Z9Z9Z9",
    role: "MSP - NOC/HD",
    company: "Xperteks Computer Consultancy, Inc.",
    date: "Jan 2025 - Apr 2025",
    desc: "• Monitored and maintained client IT infrastructure for managed service provider clients\n• Resolved technical incidents and provided help desk support\n• Managed network monitoring, troubleshooting, and incident response\n• Ensured system uptime and client satisfaction",
    skills: [
      "Network Monitoring",
      "Incident Management",
      "Help Desk Support",
      "IT Infrastructure",
      "Troubleshooting",
      "Client Support",
    ],
    doc: "",
  },
];

export const education = [
  {
    id: 0,
    img: "https://www.transparentpng.com/thumb/google-logo/google-logo-png-icon-free-download-SUF63j.png",
    school: "Google",
    date: "Apr 2024 - Jul 2024",
    grade: "N/A",
    desc: "Completed 7 courses in User Experience Design, covering essential skills and methodologies for creating user-centered designs. Gained hands-on experience with user research, prototyping, and usability testing.",
    degree: "Google UX Design Professional Certificate",
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/en/0/0d/Official_Seal_of_MSEUF.png",
    school: "Manuel S. Enverga University Foundation",
    date: "Aug 2020 - Jun 2024",
    grade: "1.424 GPA",
    desc: "Completed a BS in Information Technology, gaining expertise in programming, systems analysis, and IT management. Developed skills in designing and implementing technology solutions through practical projects.",
    degree: "BS Information Technology major in Web and Mobile Applications",
  },
];

export const projects = [
  {
    id: 5,
    title: "TrackIT — Technical Issue Reports",
    date: "Jun 2026 – Jul 2026",
    description:
      "A technical-issue ticketing platform for IT and support teams to triage, assign, and resolve reports across departments.\n\n• Built with React (Vite), Tailwind CSS, and an Express + Node.js API\n• Department-aware ticket queues with search, filters, sortable/resizable columns, and inline priority/assignee/status actions\n• Ticket detail view with helpdesk info, chat thread, internal notes, merge, and JIRA linking\n• Merged-tickets view and a filterable Reports module with CSV export\n\nThe linked demo is an interactive, frontend-only build with sample data (no backend). Use the sidebar 'Demo View' switcher to explore each department/role.",
    image: TrackITDashboard,
    tags: ["React.js", "Vite.js", "Tailwind CSS", "Node.js", "Express", "Live Demo"],
    category: "full stack",
    webapp: "https://trackit-demo-ashy.vercel.app",
    github: "https://github.com/imsteff/trackit-demo",
    member: [
      {
        name: "Stephanie Encomienda",
        img: heroImage,
        linkedin: "https://www.linkedin.com/in/imsteff-encomienda/",
        github: "https://github.com/imsteff",
      },
    ],
  },
  {
    id: 0,
    title: "Alteron Systems — Website Design & Development",
    date: "Apr 2026 – Apr 2026",
    description:
      "Built a 6-page corporate website for Alteron Systems, a UAE-based enterprise digital transformation consultancy, delivered end-to-end on WordPress.\n\n• Built all pages in WordPress using WPBakery Page Builder, with custom HTML, CSS, and JavaScript for bespoke sections and interactions\n• Implemented scroll-triggered animations and a full-screen takeover interaction on the Services page\n• Built a dynamic Insights/blog section with article templates and a lightbox image viewer\n• Managed content structure and updates across all pages",
    image: AlteronHomepage,
    tags: ["WordPress", "WPBakery", "HTML", "CSS", "JavaScript", "UI Design", "Front-End Development"],
    category: "full stack",
    webapp: "https://alteronsystems.com/",
    github: "",
    member: [
      {
        name: "Stephanie Encomienda",
        img: heroImage,
        linkedin: "https://www.linkedin.com/in/imsteff-encomienda/",
        github: "https://github.com/imsteff",
      },
    ],
  },
  {
    id: 1,
    title: "Promo Systems",
    date: "Feb 2026 – Mar 2026",
    description:
      "A web-based raffle management platform for MegaSportsWorld (MSW) that automates promotional campaigns, conducts transparent electronic draws, and generates official winner certificates.\n\n• Built full-stack raffle draw system supporting multiple raffle types including Weekly Cash Drop with configurable weekly draws, prize pools, and winner counts\n• Implemented real-time electronic draw functionality with shuffle animations, cryptographic random selection using PHP's random_int(), and complete audit trail for compliance\n• Created automated PDF certificate generation system using DomPDF with customizable templates displaying winners, prizes, and raffle entries\n• Built comprehensive raffle configuration interface allowing administrators to set qualification periods, draw dates, prize amounts, and winner counts per week",
    image: PromoSystems,
    tags: ["React.js", "Laravel", "MySQL", "PHP", "REST APIs"],
    category: "full stack",
    webapp: "https://drive.google.com/file/d/1_4gLJ7fnEqeeNTZ3dkvDHbnvoGYE_nnc/view?usp=sharing",
    github: "",
    member: [
      {
        name: "Stephanie Encomienda",
        img: heroImage,
        linkedin: "https://www.linkedin.com/in/imsteff-encomienda/",
        github: "https://github.com/imsteff",
      },
    ],
  },
  {
    id: 2,
    title: "MSW Video Call – New UI & Infrastructure Migration",
    date: "Jan 2026 – Feb 2026",
    description:
      "MSW Video Call is a real-time customer support platform that connects players with customer service agents through video calling. The system enables video communication for handling player inquiries across multiple service categories.\n\n• Developed responsive video call interface using React, TypeScript, and Vite\n• Built Picture-in-Picture (PiP) feature with drag, resize, and minimize/maximize functionality\n• Implemented real-time video/audio communication using Twilio Video SDK and WebRTC\n• Created touch-optimized controls and gesture support for mobile platforms (iOS/Android)\n• Designed dynamic UI components with Material-UI that scale across different screen sizes\n• Migrated video call platform from legacy system to new infrastructure\n• Deployed to production using GitLab CI/CD",
    image: VideoCallDesktop,
    images: [VideoCallDesktop, VideoCallAndroid, VideoCallIOS],
    tags: ["React.js", "TypeScript", "Twilio Video API", "WebRTC", "GitLab", "CI/CD", "Live Video Streaming"],
    category: "frontend",
    webapp: "https://drive.google.com/file/d/1dqV94lKPGBnVbPko9G9i3IqMCaeSj4zw/view?usp=sharing",
    github: "",
    member: [
      {
        name: "Stephanie Encomienda",
        img: heroImage,
        linkedin: "https://www.linkedin.com/in/imsteff-encomienda/",
        github: "https://github.com/imsteff",
      },
    ],
  },
  {
    id: 3,
    title: "MSW CS Helpdesk",
    date: "Aug 2025 - Oct 2025",
    description:
      "An internal ticketing platform designed for Customer Support users and players to efficiently manage and resolve inquiries.\n\n• Developed using React.js (Vite), Laravel, and MUI\n• Submit, track, and manage support tickets in real time\n• Role-based access, status tracking, and automated updates\n\nThe linked demo is an interactive, frontend-only build with sample data (no backend). Use the sidebar role switcher to explore the agent and admin views.",
    image: CSHelpdesk,
    tags: ["React.js", "Vite.js", "MUI", "Laravel", "Live Demo"],
    category: "full stack",
    webapp: "https://supportdesk-demo.vercel.app",
    github: "https://github.com/imsteff/supportdesk-demo",
    member: [
      {
        name: "Stephanie Encomienda",
        img: heroImage,
        linkedin: "https://www.linkedin.com/in/imsteff-encomienda/",
        github: "https://github.com/imsteff",
      },
    ],
  },
  {
    id: 4,
    title: "SakaNet",
    date: "Feb 2023 - Dec 2023",
    description:
      "Developed a full-stack web and mobile application that seeks to empower farmers, particularly those operating on a small to medium scale, by facilitating connections among themselves and expanding their reach to potential buyers.",
    image: sakanetImage,
    tags: ["React Js", "Next JS", "MongoDb", "Node Js", "Express Js", "MUI"],
    category: "full stack",
    webapp: "https://sakanet.vercel.app/login",
    member: [
      {
        name: "Stephanie Encomienda",
        img: heroImage,
        linkedin: "https://www.linkedin.com/in/imsteff-encomienda/",
        github: "https://github.com/imsteff",
      },
      {
        name: "Jhan Derille Unlayao",
        img: "https://avatars.githubusercontent.com/u/110339703?v=4",
        linkedin: "https://www.linkedin.com/in/jhan-derille-unlayao-9b7b5526a/",
        github: "https://github.com/D3rille",
      },
      {
        name: "Ralph Adrian Luna",
        img: "https://avatars.githubusercontent.com/u/105706278?v=4",
        linkedin: "https://www.linkedin.com/in/ralphadrianluna/",
        github: "https://github.com/RLPudge",
      },
    ],
  },
];
